import type { Statement } from '@simplywallst/services/lib/endpoints/types/company/general/CompanyAPIStatements';
import type { StatementName } from '@/hooks/useCompanyStatementsAPIFormatted/types';

export type StatementChecks = {
  mark: 'PASS' | 'FAIL';
  hash?: string;
  title?: string;
  description?: string;
};

const createChecks = (hash: string, statement?: Statement): StatementChecks => {
  const mark = statement?.value ? 'PASS' : 'FAIL';
  const formattedDescription = statement?.description?.replace(
    /\[\[(.*?)\]\]/g,
    (matched, original) => {
      return original;
    }
  );
  return {
    mark,
    hash,
    title: statement?.title,
    description: formattedDescription,
  };
};

export type StatementsMap = Record<StatementName, Statement | undefined>;

export const getStatementChecks = (
  selectedStatements: StatementName[],
  statements?: StatementsMap
) => {
  return selectedStatements.map((id) =>
    createChecks(id, statements ? statements[id] : undefined)
  );
};
